// src/Pages/Welcome.js
import React from 'react';
import { useNavigate, Link } from 'react-router-dom'; // ADD Link import
import { useIsMobile } from '../hooks/useMediaQuery'; // ADD THIS

// WWMMCGC Logo Component
const LogoSVG = ({ size }) => (
  <svg width={size} height={size} viewBox="0 0 100 100" xmlns="http://www.w3.org/2000/svg">
    <defs>
      <linearGradient id="logoGrad" x1="0%" y1="0%" x2="100%" y2="100%">
        <stop offset="0%" stopColor="#38bdf8" />
        <stop offset="100%" stopColor="#818cf8" />
      </linearGradient>
    </defs>
    <circle cx="50" cy="50" r="46" fill="none" stroke="#38bdf8" strokeWidth="1" opacity="0.3"/>
    <circle cx="50" cy="50" r="43" fill="none" stroke="#38bdf8" strokeWidth="2" opacity="0.6"/>
    <circle cx="50" cy="50" r="38" fill="none" stroke="#38bdf8" strokeWidth="3"/>
    <circle cx="50" cy="50" r="32" fill="none" stroke="#818cf8" strokeWidth="2" strokeDasharray="4,4" opacity="0.7"/>
    <circle cx="50" cy="50" r="28" fill="#0f172a"/>
    <text x="50" y="42" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="#38bdf8" textAnchor="middle">WW</text>
    <text x="50" y="58" fontFamily="Arial, sans-serif" fontSize="14" fontWeight="bold" fill="#818cf8" textAnchor="middle">MM</text>
    <text x="50" y="72" fontFamily="Arial, sans-serif" fontSize="12" fontWeight="bold" fill="#22d3ee" textAnchor="middle">CGC</text>
  </svg>
);

export default function Welcome() {
  const navigate = useNavigate();
  const isMobile = useIsMobile(); // ADD THIS

  return (
    <div style={getContainerStyle(isMobile)}>
      {/* Animated Background Blobs */}
      <div style={getBlob1Style(isMobile)}></div>
      <div style={getBlob2Style(isMobile)}></div>
      <div style={getBlob3Style(isMobile)}></div>
      
      {/* Stars/Particles */}
      <div style={starsStyle}>
        {[...Array(isMobile ? 15 : 20)].map((_, i) => (
          <div key={i} style={getStarStyle(i, isMobile)}>✦</div>
        ))}
      </div>

      {/* Main Content */}
      <div style={getContentStyle(isMobile)}>
        {/* Logo */}
        <div style={logoContainerStyle}>
          <div style={logoGlowStyle}>
            <LogoSVG size={isMobile ? 80 : 100} />
          </div>
        </div>

        {/* Title */}
        <h1 style={getTitleStyle(isMobile)}>
          WELCOME TO<br />
          WWMMCGC
        </h1>

        {/* Subtitle */}
        <p style={getSubtitleStyle(isMobile)}>
          Join the ultimate Mini Militia Classic<br />
          global community. Battle, connect, and<br />
          rise through the ranks!
        </p>
      </div>

      {/* Buttons */}
      <div style={getButtonsContainerStyle(isMobile)}>
        <button 
          onClick={() => navigate('/signup')}
          style={getJoinButtonStyle(isMobile)}
        >
          JOIN CLAN
        </button>

        <button 
          onClick={() => navigate('/login')}
          style={getLoginButtonStyle(isMobile)}
        >
          LOG IN
        </button>
      </div>

      {/* Privacy & Terms Links - ADDED */}
      <div style={getFooterLinksStyle(isMobile)}>
        <Link to="/privacy" style={footerLinkStyle}>Privacy Policy</Link>
        <span style={footerDividerStyle}>|</span>
        <Link to="/terms" style={footerLinkStyle}>Terms of Service</Link>
      </div>

      <style>{`
        @keyframes float {
          0%, 100% { transform: translate(0, 0) scale(1); }
          33% { transform: translate(30px, -30px) scale(1.1); }
          66% { transform: translate(-20px, 20px) scale(0.9); }
        }
        @keyframes twinkle {
          0%, 100% { opacity: 0.3; transform: scale(1); }
          50% { opacity: 1; transform: scale(1.2); }
        }
        @keyframes pulse-glow {
          0%, 100% { filter: drop-shadow(0 0 20px rgba(56,189,248,0.6)); }
          50% { filter: drop-shadow(0 0 40px rgba(56,189,248,0.9)); }
        }
      `}</style>
    </div>
  );
}

// Generate random star positions
const getStarStyle = (index, isMobile) => ({
  position: 'absolute',
  color: '#fff',
  fontSize: Math.random() * (isMobile ? 8 : 10) + (isMobile ? 6 : 8) + 'px',
  left: Math.random() * 100 + '%',
  top: Math.random() * 60 + '%',
  opacity: Math.random() * 0.5 + 0.3,
  animation: `twinkle ${Math.random() * 3 + 2}s ease-in-out infinite`,
  animationDelay: Math.random() * 2 + 's',
});

// Dynamic style functions
const getContainerStyle = (isMobile) => ({
  minHeight: '100vh',
  background: 'linear-gradient(180deg, #0f172a 0%, #1e3a8a 50%, #3b82f6 100%)',
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  justifyContent: 'center',
  position: 'relative',
  overflow: 'hidden',
  padding: isMobile ? '16px' : '20px',
});

const getBlob1Style = (isMobile) => ({
  position: 'absolute',
  width: isMobile ? '200px' : '300px',
  height: isMobile ? '200px' : '300px',
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(56,189,248,0.4) 0%, transparent 70%)',
  top: '10%',
  left: '-10%',
  filter: 'blur(40px)',
  animation: 'float 8s ease-in-out infinite',
});

const getBlob2Style = (isMobile) => ({
  position: 'absolute',
  width: isMobile ? '180px' : '250px',
  height: isMobile ? '180px' : '250px',
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(129,140,248,0.3) 0%, transparent 70%)',
  top: '20%',
  right: '-5%',
  filter: 'blur(50px)',
  animation: 'float 10s ease-in-out infinite reverse',
});

const getBlob3Style = (isMobile) => ({
  position: 'absolute',
  width: isMobile ? '150px' : '200px',
  height: isMobile ? '150px' : '200px',
  borderRadius: '50%',
  background: 'radial-gradient(circle, rgba(34,211,238,0.3) 0%, transparent 70%)',
  bottom: '30%',
  left: '10%',
  filter: 'blur(60px)',
  animation: 'float 12s ease-in-out infinite',
});

const starsStyle = {
  position: 'absolute',
  top: 0,
  left: 0,
  right: 0,
  bottom: 0,
  pointerEvents: 'none',
};

const getContentStyle = (isMobile) => ({
  display: 'flex',
  flexDirection: 'column',
  alignItems: 'center',
  textAlign: 'center',
  zIndex: 10,
  marginBottom: isMobile ? '40px' : '60px',
  padding: isMobile ? '0 10px' : '0',
});

const logoContainerStyle = {
  marginBottom: '30px',
};

const logoGlowStyle = {
  filter: 'drop-shadow(0 0 30px rgba(56,189,248,0.8))',
  animation: 'pulse-glow 3s ease-in-out infinite',
};

const getTitleStyle = (isMobile) => ({
  color: '#fff',
  fontSize: isMobile ? '28px' : '32px',
  fontWeight: '900',
  margin: '0 0 15px 0',
  letterSpacing: '2px',
  lineHeight: '1.2',
  textShadow: '0 4px 20px rgba(0,0,0,0.3)',
});

const getSubtitleStyle = (isMobile) => ({
  color: 'rgba(255,255,255,0.85)',
  fontSize: isMobile ? '15px' : '16px',
  lineHeight: '1.6',
  margin: 0,
  maxWidth: isMobile ? '280px' : '300px',
  padding: isMobile ? '0 10px' : '0',
});

const getButtonsContainerStyle = (isMobile) => ({
  width: '100%',
  maxWidth: isMobile ? '100%' : '320px',
  display: 'flex',
  flexDirection: 'column',
  gap: isMobile ? '12px' : '15px',
  zIndex: 10,
  marginTop: 'auto',
  marginBottom: isMobile ? '20px' : '30px',
  padding: isMobile ? '0 10px' : '0',
});

const getJoinButtonStyle = (isMobile) => ({
  width: '100%',
  padding: isMobile ? '18px' : '16px',
  borderRadius: '28px',
  border: 'none',
  background: '#fff',
  color: '#0f172a',
  fontSize: isMobile ? '17px' : '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  minHeight: '56px',
});

const getLoginButtonStyle = (isMobile) => ({
  width: '100%',
  padding: isMobile ? '18px' : '16px',
  borderRadius: '28px',
  border: 'none',
  background: 'linear-gradient(135deg, #2563eb 0%, #3b82f6 100%)',
  color: '#fff',
  fontSize: isMobile ? '17px' : '16px',
  fontWeight: 'bold',
  cursor: 'pointer',
  transition: 'all 0.3s ease',
  textTransform: 'uppercase',
  letterSpacing: '1px',
  minHeight: '56px',
});

// NEW FOOTER LINKS STYLES
const getFooterLinksStyle = (isMobile) => ({
  display: 'flex',
  alignItems: 'center',
  gap: isMobile ? '12px' : '16px',
  zIndex: 10,
  marginBottom: isMobile ? '10px' : '20px',
  fontSize: isMobile ? '12px' : '14px',
});

const footerLinkStyle = {
  color: 'rgba(255,255,255,0.7)',
  textDecoration: 'none',
  transition: 'color 0.3s ease',
};

const footerDividerStyle = {
  color: 'rgba(255,255,255,0.4)',
};